export const isSameHexColor = (color1?: string, color2?: string) => {
  return color1?.toUpperCase() === color2?.toUpperCase()
}
